var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-center",staticStyle:{"padding-top":"100px"}},[_c('van-icon',{attrs:{"name":"checked","color":"#ee0a24","size":"120"}}),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"margin":"40px","font-size":"20px"}},[_vm._v("绑定成功")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bf5dcf6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Success.vue
// module id = 4IkG
// module chunks = 1